import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { setBenchData } from "../../../redux/slice/home/sliceHome";

import { useDispatch, useSelector } from "react-redux";
import FontSizeControls from "./FontSizeControls";
import { RctBenches } from "../../../Benches/Benches";
import { setLanguage } from "../../../redux/slice/home/sliceLanguage";

const TopHeader = () => {
  const { benchData } = useSelector((state) => state.sliceHome);
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const benches = {
    Home: "/",
    AHMEDABAD: "/adi",
    ALLAHABAD: "/ald",
    AMRAVATI: "/amvt",
    BANGALORE: "/sbc",
    BHOPAL: "/bpl",
    BHUBANESWAR: "/bbs",
    CHANDIGARH: "/cdg",
    CHENNAI: "/mas",
    DELHI: "/dli",
    ERNAKULAM: "/ers",
    GORAKHPUR: "/gkp",
    GUWAHATI: "/ghy",
    JAIPUR: "/jp",
    KOLKATA: "/kol",
    LUCKNOW: "/lko",
    MUMBAI: "/mcc",
    NAGPUR: "/ngp",
    PATNA: "/pnbe",
    RANCHI: "/rnc",
    SECUNDERABAD: "/sc",
    VARANASI: "/bsb",
  };

  function getBaseBenchRoute() {
    // Get hash path and split segments
    const hashPath = window.location.hash.replace("#", ""); // remove #
    const segments = hashPath.split("/").filter(Boolean); // split and remove empty

    // Determine base route
    let baseRoute = "/"; // default
    if (segments.length > 0) {
      // Check if first segment is a bench code
      const firstSegment = segments[0].toLowerCase();
      const benchCodes = Object.values(benches).map((b) =>
        b.replace("/", "").toLowerCase(),
      );

      if (benchCodes.includes(firstSegment)) {
        baseRoute = `/${firstSegment}`; // bench base route
      }
    }

    return baseRoute;
  }

  // Usage
  const baseRoute = getBaseBenchRoute();

  const screenReaderUrl =
    baseRoute === "/" ? "/screenreader" : `${baseRoute}/screenreader`;

  // Load theme on mount
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme === "dark") {
      document.body.classList.add("black-theme");
    } else {
      document.body.classList.remove("black-theme");
    }
  }, []);

  useEffect(() => {
    if (pathname === "/") {
      dispatch(setBenchData("/"));
    }
  }, [pathname, dispatch]);
  const benchName =
    benchData === "/"
      ? {
          id: 999,
          railway_bench_name: "PRINCIPAL",
        }
      : RctBenches.find((item) => item.railway_bench_code === benchData) ||
        null;

  // Theme Handlers
  const blackTheme = () => {
    document.body.classList.add("black-theme");
    localStorage.setItem("theme", "dark");
  };

  const normalTheme = () => {
    document.body.classList.remove("black-theme");
    localStorage.setItem("theme", "light");
  };

  // Skip to main content
  const skipToMain = () => {
    window.scrollTo({
      top: 450,
      behavior: "smooth",
    });
  };

  const [toggleLanguage, setToggleLanguage] = useState(false);
  const { language } = useSelector((state) => state.sliceLanguage);

  // google translate
  useEffect(() => {
    var flags = document.getElementsByClassName("flag_link-hi");
    var flagsen = document.getElementsByClassName("flag_link-en");

    Array.prototype.forEach.call(flags, function (e) {
      e.addEventListener("click", function () {
        dispatch(setLanguage("hi"));
        // console.log("hindi clicked");
        var lang = e.getAttribute("data-lang");
        var languageSelect = document.querySelector("select.goog-te-combo");
        languageSelect.value = lang;
        languageSelect.dispatchEvent(new Event("change"));
      });
    });

    Array.prototype.forEach.call(flagsen, function (e) {
      e.addEventListener("click", function () {
        var lang = e.getAttribute("data-lang");
        var languageSelect = document.querySelector("select.goog-te-combo");
        languageSelect.value = lang;
        languageSelect.dispatchEvent(new Event("change"));
        dispatch(setLanguage("eng"));
        // console.log("english clicked");
      });
    });
  }, []);

  return (
    <>
      <div className="top-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 col-xxl-4 top-left-nav"></div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 col-xxl-8 top-right-nav">
              <ul>
                <li className="manage-bench">
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    {benchName?.railway_bench_name} Bench
                  </a>
                </li>
                <li>
                  <Link
                    to="/"
                    className="hide skiptomain"
                    onClick={() => dispatch(setBenchData("/"))}
                  >
                    {language === "hi" ? "होम" : "Home"}
                  </Link>
                </li>
                <li>
                  <Link
                    to={process.env.REACT_APP_INTERNAL_LOGIN}
                    className="hide skiptomain"
                    target="_blank"
                  >
                    Login
                  </Link>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      skipToMain();
                    }}
                    className="hide skiptomain"
                  >
                    Skip Main Content
                  </a>
                </li>
                <li>
                  <Link to={screenReaderUrl}>Screen Reader Access</Link>
                </li>
                <FontSizeControls />
                <li className="web-theme">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault(); // stops navigation to #
                      normalTheme();
                    }}
                    className="whitebg"
                  >
                    A
                  </a>

                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault(); // stops navigation to #
                      blackTheme();
                    }}
                    className="blackbg"
                  >
                    A
                  </a>
                </li>

                <li className="lang" aria-hidden="true">
                  <div
                    className="google-translate-wrap"
                    id="google_translate_element"
                    aria-hidden="true"
                  ></div>
                </li>
                <li className="lang-custom">
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      setToggleLanguage(!toggleLanguage);
                    }}
                    type="button"
                    href="#"
                  >
                    Select&nbsp;Language&nbsp;
                    <i className="fas fa-caret-down"></i>
                  </a>
                  <div
                    className={toggleLanguage ? "flag flag-language" : "flag"}
                  >
                    <span
                      className="flag_link-en en"
                      onClick={() => setToggleLanguage(!toggleLanguage)}
                      data-lang="en"
                    >
                      English
                    </span>
                    <span
                      className="flag_link-hi hi"
                      onClick={() => setToggleLanguage(!toggleLanguage)}
                      data-lang="hi"
                    >
                      हिंदी
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TopHeader;
